import React from 'react';
import { motion } from 'framer-motion';
import { RantCategory } from '../types';
import { getCategoryInfo } from '../utils/rantUtils';
interface CategoryNavProps {
  activeCategory: RantCategory;
  onCategoryChange: (category: RantCategory) => void;
}
export const CategoryNav: React.FC<CategoryNavProps> = ({
  activeCategory,
  onCategoryChange
}) => {
  const categories: RantCategory[] = ['all', 'bathroom', 'food', 'medication', 'yoga', 'emergency', 'healthy-people', 'healthcare'];
  return <div className="mb-8 overflow-x-auto pb-2" data-id="element-16">
      <div className="flex gap-2 min-w-max" data-id="element-17">
        {categories.map(category => {
        const {
          emoji,
          label
        } = getCategoryInfo(category);
        const isActive = activeCategory === category;
        return <motion.button key={category} onClick={() => onCategoryChange(category)} className={`category-tab ${isActive ? 'active' : ''}`} whileHover={{
          y: -2
        }} whileTap={{
          y: 0
        }} data-id="element-18">
              <span className="mr-2" data-id="element-19">{emoji}</span>
              {label}
              {isActive}
            </motion.button>;
      })}
      </div>
    </div>;
};